webpackJsonp([44949783951019],{

/***/ 1333:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"WastageReason","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"EXPIRED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"OTHER"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"VALIDATED_COUNT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"WASTAGE"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-wastage-reason-1034b084f7fc3ee0dac7.js